import { MaskedLines, Overline } from "./motion";
import { motion } from "framer-motion";

export const PageHeader = ({ overline, lines, subtitle }) => (
  <section className="relative pt-40 md:pt-48 pb-16 md:pb-20 border-b border-ink/10 overflow-hidden" data-testid="page-header">
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-brand-green/10 blur-[120px] pointer-events-none" />
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
      <Overline className="flex items-center gap-3">
        <span className="inline-block w-8 h-px bg-brand-green" />
        {overline}
      </Overline>
      <h1 className="mt-6 font-heading font-extrabold tracking-tighter text-ink text-[12vw] sm:text-6xl lg:text-7xl leading-[0.95]">
        <MaskedLines lines={lines} start={0.15} />
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-8 max-w-2xl font-body text-base md:text-lg text-ink/60 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
